

/* eslint-disable no-unused-expressions,  no-magic-numbers */
class LanguageSelector {

    /**
     * @param {HTMLElement} element
     * @param {Object} options
     */
    constructor(element, options) {
        const state = {
            open: false,
            index: 0,
            oldLink: null,
            newLink: null
        };

        this._state = state;
        this._element = element;
        this._options = options;

        this._handleClick = this._handleClick.bind(this);
        this._handleLinkKeyDown = this._handleLinkKeyDown.bind(this);

        this._cacheSelectors();
        this._addListeners();
    }

    /**
     *
     * Add listeners
     *
     */
    _addListeners() {
        this._button.addEventListener('click', this._handleClick);
        this._button.addEventListener('keydown', event => this._handleKeyDown(event));
        this._links.forEach(link => link.addEventListener('keydown', event => this._handleLinkKeyDown(event)));
    }

    /**
     *
     * Cache elements
     *
     */
    _cacheSelectors() {
        this._button = this._element.querySelector('.language-selector__button');
        this._links = [...this._element.querySelectorAll('.language-selector__dropdown a')];
        this._dropdown = this._element.querySelector('.language-selector__dropdown');
    }

    /**
     *
     * Opens the dropdown on click and focus on the first link
     *
     */
    _handleClick() {
        const isOpen = !this._state.open;
        this._state.open = !this._state.open;
        isOpen && this._dropdown.removeAttribute('aria-hidden');
        !isOpen && this._dropdown.setAttribute('aria-hidden', true);
        this._state.index = 0;
        isOpen && this._links[0].focus();
        this._element.setAttribute('data-active', isOpen);
    }

    /**
     *
     * Focus the first link when pressing arrow down
     * @param {Event} event
     *
     */
    _handlekKeyDown(event) {
        if (event.which === 40 && this._state.open) {
            this._links[0].focus();
        }
    }

    /**
     *
     * Navigate through links with arrow keys
     * @param {Event} event
     *
     */
    _handleLinkKeyDown(event) {
        const id = this._links.indexOf(event.currentTarget);
        // eslint-disable-next-line no-nested-ternary
        const dir = event.which === 37 ? id - 1 : event.which === 39 ? id + 1 : event.which === 40 ? 1 : 0;
        if (dir !== null) {
            const shouldFocusBack = this._state.index === 0 && dir === 0;
            if (shouldFocusBack) {
                this._button.focus();
                return;
            }
            this._state.index = dir;
            this._links[dir].focus();
        }
    }

}

export default LanguageSelector;
